export default {
  name: "footerComponent",
  data: () => ({
    base_url: process.env.VUE_APP_BASE_URL,
    categories: [],
    variables: [],
    policy_variables: [],
  }),
  mounted() {
    this.$axios.get("/category").then((res) => {
      if (res) {
        this.categories = res.data.categories;
      }
    });

    this.$axios.get("/variable?another_type=1").then((res) => {
      if (res) {
        this.variables = res.data.variables;
      }
    });

    this.$axios.get("/variable?another_type=2").then((res) => {
      if (res) {
        this.policy_variables = res.data.variables;
      }
    });
  },
};
